import React, { useState, useCallback, useEffect, useRef } from "react";
import SearchBar from "./SearchBar";
import {
  getGridValidateCheck,
  saveGridCheckData,
  isFieldDisabled,
} from "../../../utils/validators";
import ButtonBar from "../../../components/Layout/ButtonBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import { columnLayout } from "./conlumnLayout";
import useAppContext from "../../../utils/Reducers";
import { ModalVenderInfoPop } from "../../Popup/VenderInfoPop";
import { ModalRealVenderInfoPop } from "../../Popup/RealVenderInfoPop";
import "moment/locale/ko";
import { ModalDepartureMapPop } from "../../Popup/DepartureMapPop";
import { ModalDepartureReportPop } from "../../Popup/DepartureReportPop";
import { ModalLoadAreaInfoPop } from "../../Popup/LoadAreaInfoPop";
import { ModalDepartureImagePop } from "../../Popup/DepartureImagePop";
import { ModalWeighingCertificatePop } from "../../Popup/WeighingCertificatePop";
import "moment/locale/ko";
import moment from "moment";
import {
  setStorageItem,
  getStorageItem,
} from "../../../hooks/Storage/useLocalStorage";
import { ModalConfirm } from "../../../components/Confirm";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
//import PhoneInput from "react-phone-number-input/input";

//전송버튼을 클릭했을경우 함수가 외부에서 호출하여 primaryParameters 아무값도 들어가 있지 않음
//그래서 플래그를 두어 sendCnt값이 변경되면 useEffect에서 검색버튼의 함수를 실행시킴
var sendCnt = 0;
const ScrapTotalList = (props) => {
  // 푸터 설정
  var footerLayout = [
    {
      labelText: "합계",
      positionField: "#base",
    },
    {
      dataField: "plantNm",
      positionField: "plantNm",
      operation: "COUNT",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "inWgt",
      positionField: "inWgt",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outWgt",
      positionField: "outWgt",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "wtredtCd",
      positionField: "wtredtCd",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "realWgt",
      positionField: "realWgt",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
  ];

  const myGrid = useRef();

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize("100%", 600);
  }, [menuKey]);

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [""],
    updated: ["systemCd"],
  };

  //종합관제 검색 URL
  const SERARCH_TRANSTOTAL_URL = "/domesticscrap/searchScrapTransTotalList.do";

  //종합관제 검색 URL
  const SERARCH_TRANSTOTALCOUNT_URL =
    "/domesticscrap/searchScrapTransTotalCount.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_TRANSTOTAL_URL,
    },
    { manual: true }
  );

  const [primaryParameters, setPrimaryParameters] = useState({
    systemCd: "",
    schPlantCd: userInfo.defaultPlantNo,
    schVndrCd: "",
    schVndrNm: "",
    schRvndrNm: "",
    schSwghtDt: moment().format("YYYY-MM-DD"),
    schEwghtDt: moment().format("YYYY-MM-DD"),
    schVhclNo: "",
    schTransStatusCd: "",
  });

  const [totalCount, setTotalCount] = useState({
    statusA: "0",
    statusD: "0",
    statusG: "0",
    statusS: "0",
    statusT: "0",
    realWgt: "0",
  });

  //검색조건
  const setSearchParameters = (values) => {
    values.schVndrCd = userInfo.isAdmin === "N" ? userInfo.userId : "";
    setPrimaryParameters(values);
  };

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    var colLayout = columnLayout(
      popVendorInfo,
      popRealVendorInfo,
      popLoadAreaInfo,
      popDepartureMap,
      popDepartureImage,
      popRoadTicketImage,
      popWeigtingCertificate
    );
    const auiGrid = myGrid.current;
    auiGrid.create(colLayout, {
      ...defaultGridProps,
      showRowAllCheckBox: false,
      showRowCheckColumn: false,
      showStateColumn: false, // 그룹핑 후 셀 병함 실행
      // 푸터 사용 여부
      showFooter: true,
      footerPosition: "top",
    });
    // 푸터 레이아웃 세팅
    auiGrid.setFooter(footerLayout);

    //Local Storage에 저장된 그리드 컬럼 정렬정보를 가져옴
    const columnList = getStorageItem(props.menuInfo.menuId, "");
    if (columnList !== "") {
      auiGrid.setColumnOrder(columnList);
    }
    const columnSize = getStorageItem(props.menuInfo.menuId + "_s", "");
    if (columnSize !== "") {
      //Local Storage에 저장된 그리드 컬럼 Width 정보를 가져옴
      auiGrid.setColumnSizeList(columnSize);
    }
  }, []);

  const handleMasterSearch = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      params: primaryParameters,
    });
    auiGrid.setGridData(data);
    auiGrid.removeAjaxLoader();

    const response = await fetchData({
      url: SERARCH_TRANSTOTALCOUNT_URL,
      params: primaryParameters,
    });
    const count = response.data.data[0];
    //console.log(response.data.data[0]);
    setTotalCount({
      statusA: count.statusA,
      statusD: count.statusD,
      statusG: count.statusG,
      statusS: count.statusS,
      statusT: count.statusT,
      statusTotal: count.statusTotal,
      realWgt: count.realWgt,
    });
  };

  const handleMasterExcel = useCallback(() => {
    const auiGrid = myGrid.current;
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
    });
  });
  const popVendorInfo = (item) => {
    ModalVenderInfoPop({ vndrCd: item.vndrCd });
  };

  const popLoadAreaInfo = (item) => {
    ModalLoadAreaInfoPop({
      vndrCd: item.vndrCd,
      rvndrCd: item.rvndrCd,
      loadAreaCd: item.loadAreaCd,
    });
  };

  const popRealVendorInfo = (item) => {
    ModalRealVenderInfoPop({ vndrCd: item.vndrCd, rvndrCd: item.rvndrCd });
  };

  const popDepartureMap = (item) => {
    //ModalDepartureMapPop({ dprtLatt: item.dprtLatt, dprtLont: item.dprtLont });
    ModalDepartureReportPop(item);
  };

  const popDepartureImage = (event) => {
    //console.log(event.item);
    ModalDepartureImagePop({ tmsOdrNo: event.item.tmsOdrNo, type: "image" });
  };

  const popRoadTicketImage = (event) => {
    //console.log(event.item);
    ModalDepartureImagePop({ tmsOdrNo: event.item.tmsOdrNo, type: "ticket" });
  };

  const popWeigtingCertificate = (event) => {
    //console.log(event.item);
    ModalWeighingCertificatePop(event.item);
  };

  //그리드 정렬 저장
  const handleGridSorting = useCallback(() => {
    const auiGrid = myGrid.current;
    const items = auiGrid.getColumnInfoList();
    let columnList = [];
    let columnSize = [];
    items.forEach((item) => {
      columnList.push(item.dataField);
      columnSize.push(item.width);
    });
    setStorageItem(props.menuInfo.menuId, columnList);
    setStorageItem(props.menuInfo.menuId + "_s", columnSize);
    ModalConfirm({
      title: "그리드 정렬 저장",
      description: "그리드 정렬을 저장하였습니다. ",
    });
  });

  //그리드 정렬 취소
  const handleGridSortingCancel = useCallback(() => {
    setStorageItem(props.menuInfo.menuId, "");
    var colLayout = columnLayout(
      popVendorInfo,
      popRealVendorInfo,
      popLoadAreaInfo,
      popDepartureMap,
      popDepartureImage,
      popRoadTicketImage,
      popWeigtingCertificate
    );
    const auiGrid = myGrid.current;
    auiGrid.changeColumnLayout(colLayout);
    ModalConfirm({
      title: "그리드 정렬 취소",
      description: "그리드 정렬을 취소하였습니다. ",
    });
  });
  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterExcel={handleMasterExcel}
        isGridSort={true}
        handleGridSorting={handleGridSorting}
        handleGridSortingCancel={handleGridSortingCancel}
      />
      <SearchBar
        primaryParameters={primaryParameters}
        setPrimaryParameters={setPrimaryParameters}
        systemCd={userInfo.systemCd}
        searchParameters={primaryParameters}
      />

      <table className="t_garo">
        <tr>
          <td> 전체총수({totalCount.statusTotal}대)</td>
          <td>1. 운송대기({totalCount.statusT}대)</td>
          <td>2. 운송중({totalCount.statusD}대)</td>
          <td>3. 도착완료({totalCount.statusA}대)</td>
          <td>4. 입차중({totalCount.statusG}대)</td>
          <td>
            5. 출차완료({totalCount.statusS}대, {totalCount.realWgt}톤)
          </td>
        </tr>
      </table>
      <AUIGrid
        ref={myGrid}
        columnLayout={columnLayout(
          popVendorInfo,
          popRealVendorInfo,
          popLoadAreaInfo,
          popDepartureMap,
          popDepartureImage,
          popRoadTicketImage,
          popWeigtingCertificate
        )}
        gridProps={{
          ...defaultGridProps,
          showRowAllCheckBox: false,
          showRowCheckColumn: false,
          showStateColumn: false, // 그룹핑 후 셀 병함 실행
          // 푸터 사용 여부
          showFooter: true,
          footerPosition: "top",
          width: "100%",
          height: 600,
        }}
      />
    </>
  );
};

export default ScrapTotalList;
